<template>
  <div class="flex items-center gap-3 h-[var(--header-height)]">
    <GlobalPerson />    
    <Avatar @click="toggle" icon="pi pi-user" class="custom-avatar" size="large" shape="circle" />
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" class="custom-profile-menu"/>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";
import Avatar from 'primevue/avatar';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import GlobalPerson from '@/components/app/GlobalPerson';

export default {
  name: "user-menu",
  components: {
    Avatar,
    Button,
    Menu,
    GlobalPerson,
  },
  data() {
    return {  
    }
  },

  computed: {
    items() {
      return [
        { label: "Мой профиль", icon: "pi pi-user", command: () => this.goToProfile() },
        { label: "Выйти", icon: "pi pi-sign-out", command: () => this.logout() },
      ];
    }
  },

  methods: {
    async logout() {
      await AuthService.makeLogout();
    },

    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    goToProfile() {
      this.$router.push('/profile');
    },    
  },
};
</script>

<style scope>

.custom-avatar {
  background: var(--p-primary-500)!important;
}

.custom-avatar:hover {
  cursor: pointer;
}

.custom-profile-menu {
  top: var(--header-height)!important;
}

</style>
